module.exports = __webpack_public_path__ + "img/Klipsu-Eliitti-Mestari.3e057f75.png";